function log(s) {
  console.info('[react-ga]', s);
}

module.exports = log;



//////////////////
// WEBPACK FOOTER
// ../node_modules/react-ga/src/utils/console/log.js
// module id = 1430
// module chunks = 0